import api from '@/api/user'

const state = function () {
  return {
    all: [],
    zombies: [],
    info: {}
  }
}

// getters
const getters = {
  info: (state, getters) => (id) => {
    return state.info[id]
  },

  active: (state, getters) => {
    return state.all.filter(e => {
      return e.roles.length === 1 && e.roles[0] === 'user'
    })
  },

  id: state => {
    return `${state.info.id}`
  }
}

// actions
const actions = function (prefix) {
  return {
    add ({ commit }, request) {
      return api.add(prefix, request)
    },

    update ({ commit }, request) {
      return api.update(prefix, request)
    },

    remove ({ commit }, request) {
      return api.remove(prefix, request)
    },

    all ({ commit }) {
      return api.all(prefix).then((response) => {
        commit('setAll', response.data.v)
        return response
      })
    },

    zombies ({ commit }) {
      return api.zombies(prefix).then((r) => {
        commit('setZombies', r.data.v)
        return r
      })
    },

    cleanse ({ commit }, request) {
      return api.cleanse(prefix, request)
    },

    info ({ commit }, request) {
      return api.info(prefix, request).then((response) => {
        if (response.data.v != null) {
          commit('setInfo', response.data.v)
        }
        return response
      })
    }
  }
}

// mutations
const mutations = {
  setAll (state, all) {
    state.all = Object.freeze(all)
  },

  setZombies (state, all) {
    state.zombies = Object.freeze(all)
  },

  setInfo (state, user) {
    state.info[user.id] = user.info
  }
}

export default function (prefix) {
  return {
    namespaced: true,
    state,
    getters,
    actions: actions(prefix),
    mutations
  }
}
